<template>
    <div class="rsvp">
        <div class="rsvp_content">
            <img data-v-e44974fa="" src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2FRSVP%20ARRIBA.svg?alt=media&token=dcfe30ca-fcdc-47fd-9d26-eafd8c1bb207"
                style="justify-self: center; z-index: 1;">
            <div class="form_rsvp">
                <img id="logo"
                    src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2FRSVP.svg?alt=media&token=71d467de-33ff-4ceb-804a-95570493645d"
                    alt="">
                    <p>R.S.V.P</p>
                <p>Por favor confirma tu asistencia</p>
                <p>antes del 16 de mayo</p>
                
                
                <input type="text" v-model="Invitado" placeholder="Nombre" disabled>
                <select class="selectForm" v-model="num">
                    <option value="" disabled>Número de invitados</option>
                    <option v-for="index in Cantidad" :key="index" :value="index">{{ index }}</option>
                </select>
                <textarea placeholder="Mensaje para Thelma y Cristian" v-model="message"
                    style="height: 100%;"></textarea>
                <div style="display: grid; grid-template-columns: repeat(2, 1fr); column-gap: 1rem;">
                    <button style="height: 2rem; margin-bottom: 1rem; background-color: #c3c3c3; color: black; width: 8rem;"
                        @click="notAttend()">No Asistiré</button>
                    <button
                        style="height: 2rem; margin-bottom: 1rem; background-color: var(--btn);  color: var(--btn-text); width: 8rem;"
                        @click="create()">Asistiré</button>
                </div>
                <img id="LogoFinal"
                    src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2FRSVP%202%20.svg?alt=media&token=05ed7fca-06d5-451f-bda6-984d71d2b252"
                    alt="">

            </div>
            <img src="../../assets/img/template1/rsvp/combined-shape-white-bottom-01.svg" style="justify-self: center; ">
            <img data-v-e44974fa="" src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2FRSVP%20ABAJO.svg?alt=media&token=a366586e-ab70-4d18-a4a6-8bd22a857174"
                style="justify-self: center; z-index: 1; margin-top: -42px;">
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {


    name: 'RSVP',
    props: {
        Code: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            email: "",
            message: "",
            phone: "",
            num: "",
            Invitado: this.$route.query.invitado,
            Cantidad: parseInt(this.$route.query.cantidad),
        }
    },
    methods: {
        create() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}rsvp/CreateRSVP/${this.Code}` : `${process.env.VUE_APP_API_PRO}rsvp/CreateRSVP/${this.Code}`;
            let data = {
                name: this.Invitado,
                num: this.num,
                message: this.message
            }
            axios.post(url, data)
                .then((response) => {
                    if (response.status == 200) {
                        Swal.fire(
                            '',
                            'Muchas gracias por confirmar',
                            'success'
                        );
                    }
                    this.name = "";
                    this.email = "";
                    this.num = "";
                    this.message = "";
                    this.phone = "";
                })
                .catch(err => console.error(err));
        },

        goToProduct(link) {
            console.log(link);
            window.open(link, '_blank');
        },

        notAttend() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}rsvp/NotAttend/${this.Code}` : `${process.env.VUE_APP_API_PRO}rsvp/NotAttend/${this.Code}`;
            let data = {
                name: this.Invitado,
            }
            axios.post(url, data)
                .then((response) => {
                    if (response.status == 200) {
                        Swal.fire(
                            '',
                            'Muchas gracias por confirmar',
                            'success'
                        );
                    }
                    this.name = "";
                    this.email = "";
                    this.num = "";
                    this.message = "";
                    this.phone = "";
                })
                .catch(err => console.error(err));
        }

    },
}
</script>

<style scoped>
.rsvp {
   
    width: 85%;
    color: var(--text);
}

.rsvp_content {
    width: 30%;
    margin: 79px auto;
    display: grid;
}

.form_rsvp {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    place-items: center;
    background-color: #fff;
    box-shadow: 12px 0 35px -13px #cdcdcd, -12px 0 35px -13px #cdcdcd;
}

button {
    background-color: rgb(187, 148, 106);
    border-radius: 0.5rem;
    box-shadow: var(--btn-shadow);
}

button:hover {
    box-shadow: var(--btn-shadow-hover);
}

button:active {
    box-shadow: var(--btn-shadow-active);
}

input[type=text] {
    width: 90%;
}

textarea {
    width: 90%;
}

.selectForm {
    width: 90%;
    color: #6b8181;
}

#logo{
    padding-top: 1rem;
    width: 5rem;
}
#LogoFinal{
    padding-bottom: 1rem;
    width: 5rem;
}


@media (max-width: 768px) {
    .rsvp_content {
        width: 100%;
    }

    .rsvp {
       
        padding-top: 2rem;
    }
}
</style>